export const UPLOAD_FILE_TYPE = {
  cnaes_file: 'cnaes_file',
  deny_list_file: 'deny_list_file',
  employees_file: 'employees_file',
  job_roles_file: 'job_roles_file',
  occupation_areas_file: 'occupation_areas_file',
}

export const UPLOAD_FILE_NAMES = {
  cnaes_file: 'Cnaes',
  deny_list_file: 'Compliance List',
  employees_file: 'Colaboradores',
  job_roles_file: 'Cargos',
  occupation_areas_file: 'Áreas de Ocupação',
}

export const UPLOAD_FILE_URL = {
  cnaes_file: 'uploads/config/cnaes',
  deny_list_file: 'uploads/config/compliance-list',
  employees_file: 'uploads/config/employees',
  job_roles_file: 'uploads/config/job-roles',
  occupation_areas_file: 'uploads/config/occupation-areas',
}

export const DOWNLOAD_FILE_URL = {
  cnaes_file: 'cnaes/export/xlsx',
  deny_list_file: 'compliance_list/export/xlsx',
  employees_file: 'employees/export/xlsx',
  job_roles_file: 'job_role/export/xlsx',
  occupation_areas_file: 'occupation_area/export/xlsx',
}
